import React from "react";
import { Button } from "reactstrap";
import { openUploadFormModal } from "components/personal";
import { FA } from "components/FA";
import { useQuery, useSearch, useDropArea } from "hooks";
import styles from "./QueryActions.module.css";
import dragoverStyles from "components/DragOver.module.css";

const QueryActions = () => {
  const {
    setQuery,
    actions: { execute },
  } = useSearch();
  const { query, actions } = useQuery();
  const [handleDroparea, state] = useDropArea({
    onFiles: (files) => {
      openUploadFormModal(query, { target: { files } });
    },
  });
  return (
    <div className={styles.actions}>
      <Button size="sm" color="link" disabled>
        <FA icon="stream" /> Result
      </Button>
      <Button
        size="sm"
        title="Re-search saved query"
        color="action"
        onClick={() => {
          setQuery(query.parameters) || execute();
        }}
      >
        <FA icon="search" /> search
      </Button>
      <Button
        size="sm"
        color="action"
        title="Update with current search query"
        onClick={() => {
          actions.edit(query);
        }}
      >
        <FA icon="sync-alt" /> update
      </Button>
      <Button
        size="sm"
        color="action"
        onClick={() => {
          actions.delete(query.id);
        }}
      >
        <FA icon="trash" /> remove
      </Button>
      <Button
        className={`btn btn-action btn-sm${
          state.over ? ` ${dragoverStyles.dragover}` : ""
        }`}
        size="sm"
        color="action"
        onClick={openUploadFormModal}
        {...handleDroparea}
      >
        <FA icon="file-upload" /> upload
      </Button>
      <Button onClick={() => actions.current(null)} close />
    </div>
  );
};
export { QueryActions };
